import { TealiumDerivedEventData } from 'pubsub/tealium'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getUserLoggedInState } from 'redux/reducers/users'

export const useDerivedTealiumEventData = () => {
  const authenticated = useSelector(getUserLoggedInState)

  const derivedData = useMemo((): TealiumDerivedEventData => {
    return {
      // eslint-disable-next-line quote-props
      'logged_in': authenticated ? 'true' : 'false'
    }
  }, [authenticated])

  return derivedData
}
